import styled from "styled-components";

import { colors } from "../../../../../consts";
import { device } from "../../../../../services";

import WrapperContainer from "../../../../Containers/WrapperContainer";
import { Paragraph2 } from "../../../../Text/Paragraphs";
import { TextButton } from "../../../../Buttons/styled";
import {
  InfoContianer,
  NotificationContainer,
  NotificationWrapper
} from "../../../../Notification/styled";

export const ImportingSummaryWrapper = styled(WrapperContainer)`
  ${NotificationContainer}, ${NotificationWrapper} {
    width: 100%;
    max-width: 100%;
    border: none;
  }

  > ${Paragraph2} {
    font-weight: 600;
    width: 100%;
  }

  ${InfoContianer} {
    width: 100%;

    > div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      ${Paragraph2} {
        font-size: 14px;
      }
    }
  }
`;

export const DownloadButtonWrapper = styled(WrapperContainer)`
  height: 0px;

  position: relative;
  top: -30px;

  button {
    width: 197px;
    padding: unset;
    background: transparent;

    height: 40px;
    border: 2px solid;
    border-color: ${colors.RAISIN_100};

    &:hover {
      background: transparent;
      opacity: 0.7;
    }

    &:active {
      background: ${colors.RAISIN_100};
      opacity: 1;
    }

    @media screen and ${device.tablet} {
      width: fit-content;
    }
  }

  @media screen and ${device.tablet} {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const SummaryTabsWrapper = styled(WrapperContainer)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  > span {
    width: 100%;
    border-bottom: 1px solid ${colors.RAISIN_20};
  }
`;

export const TextButtonWrapper = styled(WrapperContainer)`
  padding: 0 12px;
  min-width: max-content;
  border-bottom: ${(props) =>
    props?.selected ? `1px solid ${colors.RAISIN_100}` : `1px solid ${colors.RAISIN_20}`};

  ${TextButton} {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    > span {
      height: 21px;
      padding: 0 10px;

      border-radius: 60px;
      background: ${colors.RAISIN_50};
      color: ${colors.WHITE};

      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      margin-left: 12px;
    }
  }

  &:hover {
    border-bottom: 1px solid ${colors.RAISIN_100};
  }
`;

export const TableTitle = styled(Paragraph2)`
  margin-right: auto;
`;
